import { Route, Switch } from 'react-router-dom';

import AppRedirectPage from './pages/AppRedirect';
import HomePage from './pages/Home';
import InviteExpiredPage from './pages/InviteExpired';
import NotFoundPage from './pages/NotFound';
import SharedSessionsPage from 'pages/SharedSessions';
import PlayerPerformancePage from './pages/PlayerPerformance';
import MeasurementDetailPage from './pages/MeasurementDetail';
import UsersPage from './pages/Users';
import ClientsPage from './pages/DataIntegration';
import { DefaultRoutes } from './routePaths';

export const routes = (
  <Switch>
    <Route exact path={DefaultRoutes.HomePage} component={HomePage} />
    <Route exact path={DefaultRoutes.UsersPage} component={UsersPage} />
    <Route exact path={DefaultRoutes.DataIntegrationPage} component={ClientsPage} />
    <Route exact path={DefaultRoutes.PlayerPerformancePage} component={PlayerPerformancePage} />
    <Route exact path={DefaultRoutes.MeasurementDetailPage} component={MeasurementDetailPage} />
    <Route exact path={DefaultRoutes.InviteExpiredPage} component={InviteExpiredPage} />
    <Route exact path={`${DefaultRoutes.SharedSessionsPage}/:shareCode`} component={SharedSessionsPage} />
    <Route exact path={`${DefaultRoutes.AppRedirectPage}*`} component={AppRedirectPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export const UnauthanticatedRoutes = ['sharedsession', 'appredirect'];

export const isCurrentRouteUnauth = () => {
  const currentRoute = window.location.pathname;
  const isUnauth = UnauthanticatedRoutes.some((route) => currentRoute.match(route));
  return isUnauth;
};
